import React from 'react';
import PropTypes from 'prop-types';

import FilterGroup from 'components/search_sidebar/filter_group';
import Tag from 'components/tags/tag';
import { formatDate } from 'helpers/formatters/date_time_formats';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { includes } from 'lodash';
import { Button } from 'react-bootstrap-5';
import { faEraser } from '@fortawesome/pro-regular-svg-icons';

export default class CurrentFiltersGroup extends React.Component {
  static propTypes = {
    addressFilter: PropTypes.object.isRequired,
    assetClasses: PropTypes.array.isRequired,
    associationFilters: PropTypes.object,
    availabilities: PropTypes.array.isRequired,
    availableRailProviders: PropTypes.array.isRequired,
    buildingClasses: PropTypes.array.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    filterTags: PropTypes.array,
    hideLeaseFilters: PropTypes.bool,
    hideSaleFilters: PropTypes.bool,
    industrialFilter: PropTypes.object.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    leaseFilter: PropTypes.object,
    leaseRateMappings: PropTypes.object.isRequired,
    leaseSpaceTypeMappings: PropTypes.array.isRequired,
    leaseTypeMappings: PropTypes.array.isRequired,
    lotBorderTypes: PropTypes.array.isRequired,
    lotStabilizations: PropTypes.array.isRequired,
    multifamilyFilter: PropTypes.object.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    saleFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedAvailabilities: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    servedRailProviders: PropTypes.array.isRequired,
    setAssociationFilter: PropTypes.func,
    tags: PropTypes.node,
    onAddressFilterChange: PropTypes.func.isRequired,
    onAssetClassChange: PropTypes.func.isRequired,
    onAvailabilityChange: PropTypes.func.isRequired,
    onBuildingClassChange: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onClearFilterTags: PropTypes.func,
    onIndustrialFilterChange: PropTypes.func.isRequired,
    onInvestmentTypeChange: PropTypes.func.isRequired,
    onLeaseFilterChange: PropTypes.func,
    onMultifamilyFilterChange: PropTypes.func.isRequired,
    onPropertyFilterChange: PropTypes.func.isRequired,
    onSaleFilterChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    filterTags: [],
    leaseFilter: {},
    hideLeaseFilters: false,
    hideSaleFilters: false,
  };

  handleAddressChange = (name) => {
    this.props.onAddressFilterChange(null, name);
  };

  handleCityChange = (city) => {
    const {
      addressFilter: { cities },
      onAddressFilterChange,
    } = this.props;
    const filteredCities = cities.filter(c => c !== city);
    onAddressFilterChange(filteredCities, 'cities');
  };

  handleAssetClass = (id) => {
    this.props.onAssetClassChange(parseInt(id), false);
    this.props.delayRetrieveRecords();
  };

  handleAvailabilities = (id) => {
    this.props.onAvailabilityChange(parseInt(id), false);
    this.props.delayRetrieveRecords();
  };

  handleBuildingClass = (id) => {
    this.props.onBuildingClassChange(id, false);
    this.props.delayRetrieveRecords();
  };

  handleInvestmentType = (type) => {
    this.props.onInvestmentTypeChange(type, false);
    this.props.delayRetrieveRecords();
  };

  handleMultifamilyFiltersChange = (minName, maxName) => {
    this.props.onMultifamilyFilterChange(null, minName);
    if (maxName) this.props.onMultifamilyFilterChange(null, maxName);
  };

  handlePropertyFiltersChange = (minName, maxName) => {
    this.props.onPropertyFilterChange(null, minName);
    if (maxName) this.props.onPropertyFilterChange(null, maxName);
  };

  handleSaleFiltersChange = (minName, maxName) => {
    this.props.onSaleFilterChange(null, minName);
    if (maxName) this.props.onSaleFilterChange(null, maxName);
  };

  handleIndustrialFiltersChange = (minName, maxName) => {
    this.props.onIndustrialFilterChange(null, minName);
    if (maxName) this.props.onIndustrialFilterChange(null, maxName);
  };

  handleLeaseFiltersChange = (minName, maxName) => {
    const { onLeaseFilterChange } = this.props;
    if (onLeaseFilterChange) {
      onLeaseFilterChange(null, minName);
      if (maxName) onLeaseFilterChange(null, maxName);
    }
  };

  isSelected(selected, value) {
    return includes(selected || [], value);
  }

  render() {
    const tags = this.renderTags();
    return (
      <FilterGroup
        filtersApplied={tags.length > 0}
        onClearFilters={this.props.onClearFilters}
      >
        <div className="mt-2">
          {tags.length > 0 && (
            <div className="d-flex gap-1 align-items-center">{tags}</div>
          )}
        </div>
      </FilterGroup>
    );
  }

  renderTags() {
    const tags = [];

    const {
      addressFilter,
      assetClasses,
      availabilities,
      buildingClasses,
      filterKeyMappings,
      filterTags,
      industrialFilter,
      investmentTypes,
      hideLeaseFilters,
      hideSaleFilters,
      leaseFilter,
      multifamilyFilter,
      propertyFilter,
      saleFilter,
      selectedAssetClasses,
      selectedAvailabilities,
      selectedInvestmentTypes,
      onClearFilters,
      onClearFilterTags,
    } = this.props;

    for (const key in saleFilter) {
      if (key.includes('Date') && saleFilter[key]) {
        saleFilter[key] = formatDate(saleFilter[key]);
      }
    }

    for (const key in leaseFilter) {
      if (key.includes('Date') && leaseFilter[key]) {
        leaseFilter[key] = formatDate(leaseFilter[key]);
      }
    }

    for (const key in propertyFilter) {
      if (key.includes('Date') && propertyFilter[key]) {
        propertyFilter[key] = formatDate(propertyFilter[key]);
      }
    }

    buildingClasses.map((buildingClass) => {
      const label = `Building Class: ${buildingClass}`;
      tags.push(
        this.renderTag(buildingClass, label, () => this.handleBuildingClass(buildingClass))
      );
    });

    selectedInvestmentTypes.map((type) => {
      const label = `Investment Type: ${investmentTypes.find(t => t.value === type).label}`;
      tags.push(
        this.renderTag(type, label, () => this.handleInvestmentType(type))
      );
    });

    assetClasses.map((asset) => {
      if (this.isSelected(selectedAssetClasses, asset.value)) {
        tags.push(
          this.renderTag(asset.label, 'Property Type: ' + asset.label, () => this.handleAssetClass(asset.id))
        );
      }
      (asset.subclasses || []).map((subclass) => {
        if (this.isSelected(selectedAssetClasses, subclass.value)) {
          tags.push(
            this.renderTag(
              subclass.label,
              `${asset.label} Subtype: ${subclass.label}`,
              () => this.handleAssetClass(subclass.id)
            )
          );
        }
      });
    });

    availabilities.map((availability) => {
      if (this.isSelected(selectedAvailabilities, availability.value)) {
        tags.push(
          this.renderTag(
            availability.label,
            `Availability: ${availability.label}`,
            () => this.handleAvailabilities(availability.id)
          )
        );
      }
    });

    addressFilter.cities.map((city) => {
      tags.push(
        this.renderTag(city, `City: ${city}`, () => this.handleCityChange(city))
      );
    });

    if (onClearFilterTags) {
      filterTags.map((tag) => {
        tags.push(
          this.renderTag(tag, `Tag: ${tag}`, () => onClearFilterTags(tag))
        );
      });
    }

    Object.keys(filterKeyMappings).map((filterKey) => {
      const [minKey, maxKey] = filterKeyMappings[filterKey];
      let filterTags = [];

      if (propertyFilter[minKey] || propertyFilter[maxKey]) {
        filterTags = this.renderFilterTags(
          propertyFilter,
          filterKey,
          minKey,
          maxKey,
          () => this.handlePropertyFiltersChange(minKey, maxKey)
        );
      }

      if (multifamilyFilter[minKey] || multifamilyFilter[maxKey]) {
        filterTags = this.renderFilterTags(
          multifamilyFilter,
          filterKey,
          minKey,
          maxKey,
          () => this.handleMultifamilyFiltersChange(minKey, maxKey)
        );
      }

      if (addressFilter[minKey] || addressFilter[maxKey]) {
        filterTags = this.renderFilterTags(
          addressFilter,
          filterKey,
          minKey,
          maxKey,
          () => this.handleAddressChange(minKey)
        );
      }

      if ((saleFilter[minKey] || saleFilter[maxKey]) && !hideSaleFilters) {
        filterTags = this.renderFilterTags(
          saleFilter,
          filterKey,
          minKey,
          maxKey,
          () => this.handleSaleFiltersChange(minKey, maxKey)
        );
      }

      if ((leaseFilter[minKey] || leaseFilter[maxKey]) && !hideLeaseFilters) {
        filterTags = this.renderFilterTags(
          leaseFilter,
          filterKey,
          minKey,
          maxKey,
          () => this.handleLeaseFiltersChange(minKey, maxKey)
        );
      }

      if (industrialFilter[minKey] || industrialFilter[maxKey]) {
        filterTags = this.renderIndustrialTags(filterKey, minKey, maxKey);
      }

      if (filterTags.length > 0) tags.push(filterTags);
    });

    if (this.props.associationFilters) {
      for (const key in this.props.associationFilters) {
        if (this.props.associationFilters[key]) {
          let onRemove;
          if (this.props.setAssociationFilter) {
            onRemove = () => this.props.setAssociationFilter(key, false);
          }
          tags.push(
            this.renderTag(key, this.props.filterLabelMappings[key], onRemove)
          );
        }
      }
    }

    if (this.props.tags) {
      tags.push(this.props.tags);
    }

    if (tags.length > 0) {
      tags.push(
        <Button
          key="clear-all"
          size="sm"
          variant="ghost"
          onClick={onClearFilters}
        >
          <FontAwesomeIcon icon={faEraser} size="sm" />
          Clear All
        </Button>
      );
    }

    return tags;
  }

  findLabel = (mappings, key) => {
    return mappings.find(map => map.value == key).label;
  };

  renderIndustrialTags(filterKey, minKey, maxKey) {
    const {
      industrialFilter,
      lotStabilizations,
      lotBorderTypes,
      availableRailProviders,
      servedRailProviders,
    } = this.props;

    let label = "";

    switch (filterKey) {
    case 'lotStabilization':
      label =
        'Lot  Stabilization: ' +
        this.findLabel(
          lotStabilizations,
          industrialFilter[filterKey].toString()
        );
      break;
    case 'lotBorderType':
      label =
        'Lot Border Type: ' +
        this.findLabel(
          lotBorderTypes,
          industrialFilter[filterKey].toString()
        );
      break;
    case 'servedRailProvider':
      label =
        'Served: ' +
        this.findLabel(servedRailProviders, industrialFilter[filterKey]);
      break;
    case 'availableRailProvider':
      label =
        'Available: ' +
        this.findLabel(availableRailProviders, industrialFilter[filterKey]);
      break;
    default:
      break;
    }

    const tags = [];
    if (label != '') {
      tags.push(this.renderTag(label, label, () => this.handleIndustrialFiltersChange(minKey)));
    } else {
      tags.push(this.renderFilterTags(
        industrialFilter,
        filterKey,
        minKey,
        maxKey,
        () => this.handleIndustrialFiltersChange(minKey, maxKey)));
    }

    return tags;
  }

  renderFilterLabel(filterKey, minValue, maxValue = null) {
    const {
      leaseSpaceTypeMappings,
      leaseTypeMappings,
      leaseRateMappings,
      filterLabelMappings,
      saleFilter,
      leaseFilter,
    } = this.props;

    let values =
      minValue && maxValue ? `${minValue} - ${maxValue}` : minValue || maxValue;

    if (filterKey === 'leasePrice') {
      let label = '';
      if (Object.keys(leaseFilter).length > 0) {
        label = leaseRateMappings[leaseFilter.leaseRateUnits].label;
      } else {
        label = leaseRateMappings[saleFilter.leaseRateUnits].label;
      }
      values = `$${values} ${label}`;
    } else if (filterKey === 'leaseType') {
      const type = leaseTypeMappings.find(obj => obj.id == minValue);
      values = type.label;
    } else if (filterKey === 'leaseSpaceType') {
      const type = leaseSpaceTypeMappings.find(obj => obj.id == minValue);
      values = type.label;
    }

    return `${filterLabelMappings[filterKey]}: ${values}`;
  }

  renderFilterTags(filters, filterKey, minKey, maxKey, onRemove) {
    const tags = [];
    if (maxKey && filters[maxKey]) {
      const minValue = filters[minKey] || null;
      const maxValue = filters[maxKey] || null;
      if (minValue || maxValue) {
        const label = this.renderFilterLabel(filterKey, minValue, maxValue);
        tags.push(this.renderTag(filterKey, label, onRemove));
      }
    } else if (filters[minKey]) {
      const value = filters[minKey];
      if (value) {
        const label = this.renderFilterLabel(filterKey, value);
        tags.push(this.renderTag(filterKey, label, onRemove));
      }
    }
    return tags;
  }

  renderTag(key, label, onRemove) {
    return (
      <Tag key={key} removable={true} onRemove={onRemove}>
        {label}
      </Tag>
    );
  }
}
